module.exports = "<div class=\"login-info\">\r\n  <span *ngIf=\"user?.picture\">\r\n    <!-- <a (click)=\"toggleShortcut()\"> -->\r\n     <img [src]=\"user.picture\" alt=\"me\"class=\"online\"/>\r\n     <span>{{user.username}}</span> \r\n    <!--  <i class=\"fa fa-angle-down\"></i> -->\r\n    <!-- </a> -->\r\n   </span>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/user/login-info/login-info.component.html
// module id = ./src/app/shared/user/login-info/login-info.component.html
// module chunks = main